module.exports = __webpack_public_path__ + "static/working1-923f7a7c2ad426f09a0f39c9029e330d.png";